import { connect } from "react-redux";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as yup from "yup";

import { authRequests } from "@/api/(requests)/auth";

import Button from "../../components/UI/Button";
import CompleteSignIn from "../../components/Authentication/CompleteSignIn";
import { ForgotPassword, Referral, SignIn } from "../../components/Authentication";
import { getQueryParams } from "../../utils/filters";
import {
  hideRsPwSuccess,
  logIn,
  mailResetPasswordCode,
  resetForgotPwStep,
  resetPw,
  showEmailVerified,
  signUp,
  validateReferral,
} from "../../redux/actions/auth";
import PasswordResetRequired from "../../components/Authentication/PwResetRequired";
import PatientSignUpSuccess from "../../components/Authentication/PatientSignUpSuccess";
import SelfSignUp from "../../components/Authentication/SelfSignUp/SelfSignup";
import SSO from "../../components/Authentication/SSO";
import { trackEvent } from "../../utils/EventTrackingUtil";

import ChildSignUp from "./ChildSignUp";
import PatientSignUp from "./PatientSignUp";

import "./styles.scss";

class Authentication extends Component {
  referralCodeSchema = yup.string().required("Referral code is required");

  scrlWprRef = React.createRef();
  code = getQueryParams("code", this.props.location.search);
  campaign_id = getQueryParams("campaign_id", this.props.location.search);
  state = {
    accountLocked: false,
    completeSignIn: false,
    email: "",
    forgotPasswordStep: 1,
    idpOptions: [],
    referralForm: {
      errors: [],
      referralCode: this.code ? this.code : "",
    },
    showIdp: false,
  };

  componentDidMount() {
    if (
      this.state.referralForm.referralCode &&
      window.location.pathname !== "/auth/auto-signup" &&
      window.location.pathname !== "/auth/sso"
    ) {
      this.onReferralSubmit();
    }
    if (this.campaign_id === "hcp_welcome_v1") {
      trackEvent("HCP Member on consent screen");
    }
  }

  referralChange = (e) => {
    this.setState({
      referralForm: {
        errors: [],
        referralCode: e.target.value,
      },
    });
  };

  setEmail = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  onReferralSubmit = () => {
    this.referralCodeSchema
      .validate(this.state.referralForm.referralCode)
      .then((values) => {
        this.props.validateReferral(values, () => {
          if (this.campaign_id === "child_referral_v1") {
            this.props.history.push(
              `/auth/child-sign-up?code=${this.state.referralForm.referralCode}`,
            );
          } else {
            this.props.history.push("/auth/sign-up");
          }
        });
      })
      .catch((err) => {
        this.setState((ps) => {
          return {
            ...ps,
            referralForm: {
              errors: err.errors.slice(),
            },
          };
        });
      });
  };

  resetCodeHandler = () => {
    this.props.mailResetPasswordCode(this.state.lastSubmittedEmail);
    this.setState({ email: this.state.lastSubmittedEmail });
    this.props.history.push("/auth/forgot-password");
  };

  checkIdp = async (email) => {
    const data = {
      email: email,
    };

    try {
      const response = await authRequests.get_user_idp({ data });

      if (response.idp_login_url && response.idp_login_url.length) {
        this.setState({ idpOptions: response });
        localStorage.setItem("idpOptions", JSON.stringify(response));
        localStorage.setItem("idpLoginUrl", response.idp_login_url);
        localStorage.setItem("idpLogoutUrl", response.idp_logout_url);
        localStorage.setItem("idpPrincipleUser", email);
        localStorage.setItem("ssoInProgress", true);
        this.setState({ showIdp: true });
        this.setState({ email: email });
        this.props.history.push("/auth/sso");
      } else {
        this.setState({ completeSignIn: true }, function () {
          this.props.history.push("/auth/complete-sign-in");
        });
      }
    } catch (e) {
      console.log(e);
      this.setState({ completeSignIn: true }, function () {
        this.props.history.push("/auth/complete-sign-in");
      });
    }
  };

  check_if_idp = async (values, actions) => {
    actions.setSubmitting(false);
    this.checkIdp(values.USERNAME);
    this.setState({ email: values.USERNAME });
  };

  submitHandlerSignIn = async (values, actions) => {
    actions.setSubmitting(false);
    if (this.state.lastSubmittedEmail && this.state.email !== this.state.lastSubmittedEmail) {
      this.setState({ accountLocked: false });
    }

    values["USERNAME"] = this.state.email;
    await this.props.logIn(values);

    if (this.props.auth.errorType && this.props.auth.errorType === "UserLockedOutException") {
      this.setState({ lastSubmittedEmail: values.USERNAME });
      this.setState({ accountLocked: true });
    } else if (this.props.auth.errorType && this.props.auth.errorType === "PasswordResetRequired") {
      this.props.history.push("/auth/password-reset-required");
    }
  };

  // handlers for reset/forgot password screens
  mailResetPwCode = (form, actions) => {
    actions.resetForm();
    this.props.mailResetPasswordCode(form.email);
    // this.setState({
    //     forgotPasswordStep: 2
    // })
  };

  resetPwCodeAgain = (email) => {
    this.props.mailResetPasswordCode(email);
  };

  resetPwSteps = () => {
    this.props.resetForgotPwStep();
  };
  setNewPasswordHandler = (form, actions) => {
    let formCopy = Object.assign({}, form);

    delete formCopy.ConfirmPassword;
    delete formCopy.email;
    if (this.props.auth.forgotPasswordEmail) {
      formCopy["Username"] = this.props.auth.forgotPasswordEmail;
      this.props.resetPw(formCopy, (success) => {
        actions.setSubmitting(false);
        if (success) {
          this.props.history.push({ pathname: "/auth/sign-in" });
          actions.resetForm();
          this.setState({ accountLocked: false });
        }
      });
    }
  };

  setNewPasswordWithEmailHandler = (form, actions) => {
    let data = {
      confirmation_code: form.confirmation_code,
      Password: form.Password,
      Username: form.email,
    };

    this.props.resetPw(data, (success) => {
      actions.setSubmitting(false);
      if (success) {
        this.props.history.push({ pathname: "/auth/sign-in" });
        this.setState({ accountLocked: false });
      }
    });
  };

  showEmailVerifiedPopUp = () => {
    this.props.showEmailVerified(true);
  };

  scrollToTop = () => {
    this.scrlWprRef.current.scrollTop = 0;
  };

  emailVerifiedMarkup = (
    <div>
      <h6>
        <b>Email Verified</b>
      </h6>
      <p className="mt-4 fs-14">Congratulations! Your email address is successfully verified</p>
      <div className="d-flex pr-5 tw:justify-center">
        <Button
          className="Btn Btn--pri Btn-sm mt-4"
          onClick={() => this.props.history.push({ pathname: "/auth/sign-in" })}
        >
          {" "}
          Continue
        </Button>
      </div>
    </div>
  );
  // formWprRef = React.createRef()

  safeGetPracticeId = () => {
    if (
      this.props.auth &&
      this.props.auth.referralResponse &&
      this.props.auth.referralResponse.pcp_practice_id
    ) {
      return this.props.auth.referralResponse.pcp_practice_id;
    }

    return null;
  };

  render() {
    let showSvgArt = !this.props.auth.referralResponse && !this.props.auth.referralCodeMailed;

    return (
      <Switch>
        <Route
          path="/auth/sso/:providerName/:email"
          render={(props) => (
            <SSO
              {...props}
              emailVerified={this.showEmailVerifiedPopUp}
              submit={this.submitHandlerSignIn}
            />
          )}
        />
        <Route
          path="/auth/sso"
          render={(props) => (
            <SSO
              {...props}
              email={this.state.email}
              emailVerified={this.showEmailVerifiedPopUp}
              idpOptions={this.state.idpOptions}
              showIdp={this.state.showIdp}
              submit={this.submitHandlerSignIn}
            />
          )}
        />

        <Route
          path="/auth/sign-in"
          render={(props) => (
            <SignIn
              {...props}
              accountLocked={this.state.accountLocked}
              email={this.state.email}
              emailVerified={this.showEmailVerifiedPopUp}
              resetPwSteps={this.resetPwSteps}
              submit={this.check_if_idp}
            />
          )}
        />
        <Route
          path="/auth/complete-sign-in"
          render={(props) => (
            <CompleteSignIn
              {...props}
              accountLocked={this.state.accountLocked}
              completeSignIn={this.state.completeSignIn}
              email={this.state.email}
              lastSubmittedEmail={this.state.lastSubmittedEmail}
              resetCodeHandler={this.resetCodeHandler}
              setEmail={this.setEmail}
              submit={this.submitHandlerSignIn}
            />
          )}
        />

        {this.props.auth.referralResponse && (
          <Route
            path="/auth/sign-up"
            render={(props) => (
              <PatientSignUp
                {...props}
                campaignId={this.campaign_id}
                practiceId={this.safeGetPracticeId()}
                refFromOuter={this.scrlWprRef}
                scrollToTop={this.scrollToTop}
                showArt={showSvgArt}
              />
            )}
          />
        )}
        {this.props.auth.referralResponse && (
          <Route
            path="/auth/child-sign-up"
            render={(props) => (
              <ChildSignUp {...props} referralInfo={this.props.auth.referralResponse} />
            )}
          />
        )}
        {this.props.auth.referralCodeMailed && (
          <Route
            path="/auth/sign-up"
            render={() => (
              <PatientSignUpSuccess
                logIn={this.props.logIn}
                refFromOuter={this.scrlWprRef}
                showArt={showSvgArt}
              />
            )}
          />
        )}

        {!this.props.auth.referralResponse && !this.props.auth.referralCodeMailed && (
          <Route
            path="/auth/referral"
            render={(props) => (
              <Referral
                {...props}
                onReferralSubmit={this.onReferralSubmit}
                referralChange={this.referralChange}
                referralForm={this.state.referralForm}
                refFromOuter={this.scrlWprRef}
                showArt={showSvgArt}
              />
            )}
          />
        )}
        <Route
          path="/auth/forgot-password"
          render={(props) => (
            <ForgotPassword
              {...props}
              currentStep={this.props.auth.forgotPasswordStep}
              emailFromPrevStep={this.state.email}
              sendResetPasswordCode={this.mailResetPwCode}
              setNewPassword={this.setNewPasswordHandler}
              setNewPasswordWithEmail={this.setNewPasswordWithEmailHandler}
            />
          )}
        />

        <Route component={SelfSignUp} path="/auth/self-signup/:step" />
        <Route component={SelfSignUp} path="/auth/self-signup" />
        <Route component={PasswordResetRequired} path="/auth/password-reset-required" />

        {this.props.configs.TEENS_AND_KIDS_FLOW && (
          <>
            {/* <Route path="/auth/signup/:step" component={SignUp} /> */}
            {/* <Route path="/auth/signup" component={SignUp} /> */}
          </>
        )}

        <Redirect to="/auth/sign-in" />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    configs: state.configs,
  };
};

export default connect(mapStateToProps, {
  hideRsPwSuccess,
  logIn,
  mailResetPasswordCode,
  resetForgotPwStep,
  resetPw,
  showEmailVerified,
  signUp,
  validateReferral,
})(Authentication);
